import React from 'react';
import { get } from 'lodash';
import { COUNTRY_CODES } from 'shared/constants';
import classes from './Style.module.scss';

const COUNTRY = Object.values(COUNTRY_CODES)
  .filter((country) => country.code)
  .map((country) => [country.code, country]);

const UNIQUE_COUNTRY = [...new Map(COUNTRY).values()];

export const PHONE_CODE_OPTIONS = UNIQUE_COUNTRY.map((country) => ({
  raw: country,
  label: (
    <span className={classes.phoneCodeOption}>
      <span className={`flag-icon flag-icon-${(get(country, 'iso2', '') || '').toLowerCase()}`} />
      {country.code ? `+${country.code.replace(' ', '')}` : ''}
    </span>
  ),
  value: country.code ? `+${country.code.replace(' ', '')}` : '',
}));
